/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Upgrade_CtaInputs */

const en_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Plans`)
};

const de_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pläne ansehen`)
};

const fr_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les plans`)
};

const es_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver planes`)
};

const it_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi piani`)
};

const nl_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk plannen`)
};

const pl_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz plany`)
};

const fi_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä suunnitelmat`)
};

const da_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se planer`)
};

const sv_analytics_upgrade_cta = /** @type {(inputs: Analytics_Upgrade_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa planer`)
};

/**
* | output |
* | --- |
* | "View Plans" |
*
* @param {Analytics_Upgrade_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_upgrade_cta = /** @type {((inputs?: Analytics_Upgrade_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Upgrade_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_upgrade_cta(inputs)
	if (locale === "fr") return fr_analytics_upgrade_cta(inputs)
	if (locale === "es") return es_analytics_upgrade_cta(inputs)
	if (locale === "it") return it_analytics_upgrade_cta(inputs)
	if (locale === "nl") return nl_analytics_upgrade_cta(inputs)
	if (locale === "pl") return pl_analytics_upgrade_cta(inputs)
	if (locale === "fi") return fi_analytics_upgrade_cta(inputs)
	if (locale === "da") return da_analytics_upgrade_cta(inputs)
	if (locale === "sv") return sv_analytics_upgrade_cta(inputs)
	return en_analytics_upgrade_cta(inputs)
});